import { SHIPPING_RATES } from "constants/action-types";
import { updateWorkingOrderState, type IReviewTabStateAction } from "./working-order-state";
import { getShippingKey } from "helpers/shipping-rates";

export const fetchShippingRates =
    (payload: IReviewTabStateAction["payload"], meta?: IReviewTabStateAction["meta"]) => (dispatch) => {
        if (meta.shippingEnabled) {
            dispatch({
                type: SHIPPING_RATES.FETCH.START,
                payload: { order: { ...payload.order, __company: payload.order.retailer.ref } },
                meta: { ...meta, shippingKey: meta.shippingKey || getShippingKey(payload, meta) },
            });
            return;
        }

        dispatch({
            type: SHIPPING_RATES.FETCH.SUCCESS,
            payload: { ratesBySplit: [], error: null }, // ensure store contains empty rates
            meta: { ...meta, shippingKey: meta.shippingKey || getShippingKey(payload, meta) },
        });
        dispatch(updateWorkingOrderState({ shippingRates: true }, meta));
    };
